// Used in assignables-list.component.html, resource-assignables.component.html, and resources-list.component.html

// Angular
import { Component, Input, Output, EventEmitter, OnInit } from "@angular/core";

export interface AddToCartEvent {
    detail: boolean;
}

@Component({
    selector: "add-to-cart-btn",
    templateUrl: "./add-to-cart-btn.component.html",
    styleUrls: ["./add-to-cart-btn.component.scss"],
    standalone: false
})
export class AddToCartBtnComponent implements OnInit {
    @Input() checked: boolean;
    @Input() disabled?: boolean;

    @Output() plusClick = new EventEmitter<AddToCartEvent>();

    constructor() {}

    ngOnInit() {
        if (!this.disabled) {
            this.disabled = false;
        }
    }

    emitBtnClick() {
        this.plusClick.emit({ detail: !this.checked });
    }

    getTooltip() {
        if (this.disabled) {
            return "Cannot assign Bundles to cart while in Bundle creation mode";
        } else {
            return "Add to cart";
        }
    }
}
